import { useParams, Navigate } from "react-router-dom";
import { Check, ArrowRight, Gauge } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import Configurator from "@/components/Configurator";
import { PageHero, CTABand } from "@/components/blocks";
import { STAGES } from "@/data/content";
import { useUI } from "@/context/UIContext";

export default function StagePage() {
  const { stage } = useParams();
  const { openLead } = useUI();
  const data = STAGES[stage];
  if (!data) return <Navigate to="/reprogrammation" replace />;

  return (
    <div data-testid="stage-page">
      <Seo title={`${data.name} — Reprogrammation moteur | Horsepower Garage`}
        description={`${data.name} : ${data.short}. ${data.intro.slice(0, 120)}`}
        canonical={`https://www.horsepowergarage.fr/reprogrammation/${stage}`} />
      <PageHero eyebrow="Reprogrammation moteur" title={data.name} subtitle={data.short} image={data.hero} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-12">
          <Reveal>
            <p className="text-neutral-300 text-lg leading-relaxed">{data.intro}</p>
            <div className="mt-6 p-5 border-l-2 border-hp-yellow bg-hp-carbon">
              <p className="text-sm uppercase tracking-widest text-hp-yellow font-bold mb-1">Gains</p>
              <p className="text-white">{data.gains}</p>
            </div>
            <button onClick={() => openLead({ request_type: "devis", service: data.name, stage: data.name })}
              className="hp-cta mt-8 px-7 py-4 text-sm inline-flex items-center gap-2" data-testid="stage-devis">
              Demander un devis {data.name} <ArrowRight size={16} />
            </button>
          </Reveal>
          <Reveal delay={0.1}>
            <ul className="space-y-4">
              {data.points.map((p) => (
                <li key={p} className="flex items-start gap-3 hp-card p-4">
                  <Check className="text-hp-yellow shrink-0 mt-0.5" size={20} />
                  <span className="text-neutral-200">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center gap-3 mb-8">
          <Gauge className="text-hp-yellow" size={22} />
          <h2 className="font-display font-bold uppercase tracking-tight text-2xl">Configurez votre véhicule</h2>
        </div>
        <Configurator />
      </section>

      <CTABand />
    </div>
  );
}
